import { useTranslation } from "react-i18next";

const bnMonths = [
  "জানুয়ারি", "ফেব্রুয়ারি", "মার্চ", "এপ্রিল", "মে", "জুন",
  "জুলাই", "আগস্ট", "সেপ্টেম্বর", "অক্টোবর", "নভেম্বর", "ডিসেম্বর"
];

const enMonths = [
  "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
  "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
];

export const formatDateByLang = (dateString, lang) => {
  // convert "28 NOV 2024" → JS Date
  const [day, monthStr, year] = dateString.split(" ");
  const monthIndex = enMonths.findIndex(m => m === monthStr.toUpperCase());

  if (monthIndex === -1) return dateString; // fallback if parse fails

  if (lang === "bn") {
    // Convert numbers and month name to Bangla
    const banglaNumbers = {
      "0": "০", "1": "১", "2": "২", "3": "৩", "4": "৪",
      "5": "৫", "6": "৬", "7": "৭", "8": "৮", "9": "৯"
    };

    const convertToBnNum = (numStr) =>
      numStr.split("").map(ch => banglaNumbers[ch] || ch).join("");

    return `${convertToBnNum(day)} ${bnMonths[monthIndex]} ${convertToBnNum(year)}`;
  }

  // Default English
  return `${day} ${enMonths[monthIndex]} ${year}`;
};
